

/**
* directives.carousel Module
*
* Description
*/
var app = angular.module('directives.sendsms', []);

	require('./stylesheet/sendsms.scss');
	require('./directives/sendsms.js');

module.exports = app;


/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/sendsms/index.js
 ** module id = 223
 ** module chunks = 1
 **/